import { push } from 'react-router-redux'
import { Observable } from 'rxjs'

const notFoundEpic = (action$) => action$
  .ofType('NOT_FOUND')
  .mergeMap(_ => Observable
    .of(
      push('/404')
    )
  )

export {
  notFoundEpic,
}
